<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="subtitle">Votre demande a été effectué avec succès</h2>
        <p>Votre commande est en cours de traitement.</p>
        <p>Une confirmation de commande vous sera transmis dans peu de temps par email à l’adresse {{currentUser.email}}.</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <hr style="border: none;border-bottom: 1px solid #e2e2e2;" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h2 class="subtitle">Numéro de votre commande : {{order.id}}</h2>
        <h2 class="subtitle">{{order.orderDate}}</h2>
        <p>{{order.service.name}}</p>
        <h2>Montant : {{(order.amount) ? $format.money(order.amount): $format.money(order.price)}}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <hr style="border: none;border-bottom: 1px solid #e2e2e2;" />
      </v-col>
    </v-row>
    <v-row>
      <v-btn text to="/services/list">
        <v-icon left>mdi-arrow-left</v-icon>Retour aux services
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("orderForm", ["order"]),
    ...mapGetters("auth", ["currentUser"])
  }
};
</script>

<style>
</style>